import { Component, Input } from '@angular/core';

/**
 * Normal binding doesnt work here, attribute binding is necessary ..
 *
 * @see http://stackoverflow.com/questions/36099392/how-to-use-angular-2-extrapolation-in-html-element-attributes
 */
@Component({
    selector: 'render-checkout-icon',
    template: ` @if (fastCheckout) {
  <svg
    class="icon-truck"
    [attr.width]="iconWidth"
    [attr.height]="iconHeight"
    viewBox="0 0 46 24"
    >
    <use xlink:href="/images/icons/svg-sprite.svg#truck"></use>
  </svg>
}
@if (!fastCheckout) {
  <svg
    class="icon-shoppingcart"
    [attr.width]="iconWidth"
    [attr.height]="iconHeight"
    viewBox="0 0 27 24"
    >
    <use xlink:href="/images/icons/svg-sprite.svg#shoppingcart"></use>
  </svg>
}`,
    standalone: true
})
export class RenderCheckoutIconComponent {
  @Input() fastCheckout: boolean;
  @Input() iconWidth: string;
  @Input() iconHeight: string;
}
